<template>
  <div v-if="$store.state.warning.warningFalg">
    <div class="modal-backdrop fade in" style="z-index: 1040;"></div>
    <div
      class="modal fade ng-isolate-scope in"
      animate="animate"
      style="z-index: 1050; display: block;"
      @click.stop="cancel"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="inmodal">
            <div class="modal-content animated fadeIn">
              <div class="modal-header">
                <button type="button" class="close" @click.stop="cancel">
                  <span aria-hidden="true">&times;</span>
                  <span class="sr-only">Close</span>
                </button>
                <span class="text-warning">
                  <i class="fa fa-exclamation-triangle modal-icon"></i>
                </span>
                <h4 class="modal-title">Warning</h4>
              </div>
              <div class="modal-body">
                <p class="wrap">{{$store.state.warning.warningMsg}}</p>
              </div>
              <div class="modal-footer" id="warnBtnWrap">
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "warningDlgController",
  data() {
    return {};
  },
  methods: {
    cancel: function() {
      this.$store.commit("setwarning", { string: "", boolean: false });
    }
  },
  mounted: function() {
    var that = this;
    this.$router.beforeEach((to, from, next) => {
      window.scrollTo(0,0);
      if (to.meta.title) {
        that.$store.commit("setPageTitle", to.meta.title)
        document.title = 'WKCDA-cms | '+that.$store.state.pageTitle
      }
      if(that.$store.state.edit){
        that.$store.commit("setwarning", {
          string: 'Do you want to leave without saving changes?',
          boolean: true,
          button: [{
              name:'Stay',
              callBack:function(){
              }
            }, {
              name:'Leave',
              callBack:function(){
                
                $('.spiner-postion').removeClass('hide');
                next();
              }
            }]
        });
      }else{
        $('.spiner-postion').removeClass('hide');
        next();
      }
    })
    this.$router.afterEach((to, from, next) => {
      $('.spiner-postion').addClass('hide');
      that.$store.state.edit = false;
    })
  }
};
</script>
